import type { RouteObject } from "react-router";
import SignIn from "./ui/pages/SignIn";
import SignUp from "./ui/pages/SignUp";
import ResetPassword from "./ui/pages/ResetPassword";
import VerifyEmailPage from "./ui/pages/VerifyEmailPage";
import AuthActionPage from "./ui/pages/AuthActionPage";
import MfaSetupPage from "./ui/pages/MfaSetupPage";
import GoogleAuthenticatorGuide from "./ui/pages/GoogleAuthenticatorGuidePage";
import ProtectedRoute from "./ui/components/ProtectedRoute";
import InvitePage from "./ui/pages/InvitePage";

export const authRoutes: RouteObject[] = [
    { path: "/login", element: <SignIn /> },
    { path: "/signup", element: <SignUp /> },
    { path: "/invite/:token", element: <InvitePage /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "/verify-email", element: <VerifyEmailPage /> },
    { path: "/auth/action", element: <AuthActionPage /> },
    { path: "/google-authenticator-guide", element: <GoogleAuthenticatorGuide /> },
    {
        path: "/mfa-setup",
        element: (
            <ProtectedRoute>
                <MfaSetupPage />
            </ProtectedRoute>
        ),
    },
];
